<template>
  <div>
    <Header :title="title" :right-content="rightContent" />
    <div>
      <!-- <swiper ref="mySwiper" :options="swiperOption">
        <swiper-slide
          v-for="(item, index) in accountLevelList"
          :key="'accountLevelDetails-' + index"
        > -->
      <div class="accLevel" :class="isIndex">
        <div id="content">
          <div class="accStatus" :class="isIndex">
            <span>{{
              isIndex == "ECN"
                ? "ECN"
                : isIndex == "MIN"
                  ? "迷你"
                  : isIndex == "STD"
                    ? "标准"
                    : isIndex == "PLA"
                      ? "铂金"
                      : altFlavors.includes(flavor) ? "特选" : "巴菲特"
            }}账户</span>
          </div>
          <div class="accCon">
            <div class="accNav">
              <ul>
                <li
                  v-for="(item, index) in accountLevelList"
                  :key="index"
                  :class="[{ checked: isIndex == index }, index]"
                  @click="tabClick(index)"
                >
                  <span :class="index" />
                </li>
              </ul>
            </div>
            <div class="accList">
              <ul>
                <li>
                  <span>累计净入金门槛</span><span>{{
                    isIndex == "MIN"
                      ? "25"
                      : (isIndex == "STD" || isIndex == "ECN")
                        ? "100"
                        : isIndex == "PLA"
                          ? "5000"
                          : "20000"
                  }}美元</span>
                </li>
                <li>
                  <span>最小下单手数</span><span>{{
                    (isIndex == "MIN" || isIndex == "ECN")
                      ? "0.01"
                      : isIndex == "STD"
                        ? "外汇0.05手，其他产品0.01"
                        : isIndex == "PLA"
                          ? "0.1"
                          : "0.5"
                  }}手</span>
                </li>
                <li>
                  <span>最大订单量
                    <p>(挂单)</p></span><span>{{ isIndex == "MIN" ? "50" : "100" }}张</span>
                </li>
                <li><span>杠杆</span><span v-if="isIndex == 'ECN'">100倍</span><span v-else>最高500倍</span></li>
                <li v-if="isIndex == 'ZER'">
                  <span>佣金</span><span>每手10-12美元</span>
                </li>
                <li>
                  <span>最低浮动点差
                    <p>(外汇)</p></span><span>{{
                    isIndex == "ECN"
                      ? 1
                      : isIndex == "MIN"
                        ? "1.6"
                        : isIndex == "STD"
                          ? "1.2"
                          : isIndex == "PLA"
                            ? "1.0"
                            : "0"
                  }}</span>
                </li>
                <li v-if="isIndex == 'ZER'">
                  <span>账户净存利息回赠</span><span>有</span>
                </li>
                <li v-if="isIndex == 'ZER'">
                  <span>专属客户经理</span><span>有</span>
                </li>
                <li v-if="isIndex == 'ZER' || isIndex == 'PLA'">
                  <span>生日礼遇</span><span>{{
                    isIndex == "PLA"
                      ? "价值30美元生日奖赏"
                      : "价值200美元的生日奖赏"
                  }}</span>
                </li>
              </ul>
              <a
                v-if="currentAcc !== 'ECN' && isIndex == currentAcc && newAccountLevel != ''"
                @click="getNextAccountLevel(isIndex)"
              >立即升级</a>
            </div>
            <div class="accExplain">
              <p>* 具体佣金收费请到差价合约价格与收费</p>
              <p>* {{ altFlavors.includes(flavor) ? "特选" : "巴菲特" }}级账户权利受账户条款及细则约束</p>
              <p>
                * 生日礼遇：生日往前计算两个月的 1 日至生日当月结束，期间铂金账户需平仓最少20手；{{ altFlavors.includes(flavor) ? "特选" : "巴菲特" }}级账户需平仓最少50手。
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- </swiper-slide>
      </swiper> -->
    </div>
  </div>
</template>

<script>
// require('swiper/css/swiper.css')
require('@/assets/css/accLevel.css')
import Header from '@/view/module/Header.vue'
import api from '@/plugins/api'
import { mapState } from 'vuex'
import { isMT5Enabled } from '@/utils/helper'
// import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  name: 'AccLevel',
  components: { Header },
  computed: {
    ...mapState(['gts2AccountId', 'altFlavors']),
    // swiper() {
    //   return this.$refs.mySwiper.swiper
    // }
  },
  data() {
    return {
      title: '账户级别',
      rightContent: 'isNo',
      accountLevelList: Object.keys(JSON.parse(process.env.VUE_APP_LEVEL)).filter(key => !['EXC', 'AGT', ...!isMT5Enabled() ? ['ECN'] : []].includes(key)).reduce((res, key) => (res[key] = JSON.parse(process.env.VUE_APP_LEVEL), res), {}),
      isIndex: (this.$route.query.accountLevel == 'EXC' ? 'STD' : this.$route.query.accountLevel) || 'MIN',
      // slideIndex: ['MIN', 'STD', 'PLA', 'ZER'],
      currentAcc: this.$route.query.accountLevel || '',
      // sliderNum: 0,
      // swiperOption: {
      //   notNextTick: true,
      //   initialSlide: this.sliderNum,
      //   resistanceRatio: 0,
      //   slidesPerView: 'auto',
      //   slideToClickedSlide: true,
      //   on: {
      //     slideChangeTransitionEnd: function() {
      //       _this.isIndex = _this.slideIndex[this.activeIndex]
      //       // console.log(_this.sliderNum)
      //     }
      //     // init(){
      //     //    const activeTab = _this.slideIndex.indexOf(_this.currentAcc);
      //     //   swiper.slideTo(activeTab)
      //     // }
      //   }
      // },
      newAccountLevel: '',
      flavor: this.$route.query.flavor
    }
  },
  mounted() {
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
    this.getAccountLevel()
    // this.setCurrentSlideNum()
  },
  activated() {
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
  },
  methods: {
    // setCurrentSlideNum() {
    //   const activeTab = this.slideIndex.indexOf(this.currentAcc)
    //   this.swiper.slideTo(activeTab)
    //   // console.log(this.sliderNum);
    // },
    tabClick(index) {
      this.isIndex = index
    },
    getNextAccountLevel(accountLevel) {
      this.$bus.$emit('loading', false)
      this.$router.push({
        path: '/home/accUpgrade',
        query: { accountLevel: accountLevel, flavor: this.flavor }
      })
    },
    getAccountLevel() {
      api.getAccountLevelByGts2AccountId(this.gts2AccountId).then((res) => {
        if (res.status == 200 && res.data.code == 200) {
          if (res.data.data) {
            for (const i in res.data.data) {
              this.newAccountLevel = i
            }
          }
        }
      })
    }
  }
}
</script>
